import { Horizontal, Vertical } from "@/components/standard/BFLayout"
import { H2, H6, Subtitle } from "@/components/standard/BFText"

export const SetupHeader = ({
  title,
  subtitle,
  stepData,
}: {
  title: string
  subtitle?: string
  stepData?: [number, number]
}) => {
  return (
    <Horizontal className={"w-full px-4 py-5 items-start"}>
      <Vertical className={"flex-1 gap-2"}>
        <H2 color={"primary"}>{title}</H2>
        {subtitle && <Subtitle color={"primary"}>{subtitle || ""}</Subtitle>}
      </Vertical>
      {stepData && (
        <Horizontal className={"ml-4 mt-1 rounded-lg bg-calm-blue px-2"}>
          <H6 color={"white"}>
            {stepData[0]} OF {stepData[1]}
          </H6>
        </Horizontal>
      )}
    </Horizontal>
  )
}
